import { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, Outlet } from "react-router-dom"; 
import "../CommerceManager/Commercemanagerdashboard.css";
import WebsiteLogo from "../assets/images/logo.png";
import loaderAnimation from "../assets/lottie/Success.json";


import { 
  FaTachometerAlt,
  FaDollarSign, 
  FaQuestionCircle, FaSignOutAlt, FaBars, 
  FaGift,
  FaBusinessTime,
  FaStar
} from "react-icons/fa";
import Swal from "sweetalert2";
import { removeToken } from "../whatsapp/function/token";
import Loader from "../CommerceManager/component/Loader";
import BusinessModal from "./BusinessModal";
import { startGoogleAuth } from "./function";
import Lottie from "lottie-react";
import { ErrorToastContainer, SuccessToastContainer } from "../whatsapp/function/CustomFunction";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const lottieRef = useRef(false);
  const dataRef = useRef([]);
  const Services = useSelector((state) => state.serviceStore.value);
  const Accesstoken = useSelector((state) => state.Token.value);

  const handleMenuClick = (menuName) => {
    if (activeMenu !== menuName) {
      setActiveMenu(menuName);
    }else{
      setActiveMenu("");
    }
  };

  const handleSubMenuClick = (subMenuName) => {
      setActiveSubMenu(subMenuName);
  };

  return (
    <div className="commerce_dashboard-wrapper">
      
      {/* Overlay for Mobile */}
      {isSidebarOpen && (
        <div className="commerce_overlay d-lg-none" onClick={() => setIsSidebarOpen(false)}></div>
      )}

      <div className={`commerce_sidebar d-flex flex-column py-3d ${isSidebarOpen ? 'commerce_active-mobile' : 'commerce_closed'}`}>
        <div className="commerce_sidebar-logo-container">
            <img src={WebsiteLogo} alt="logo" />
        </div>
        <div className="bg-white" style={{height: "5px"}}></div>
        <div className="flex-grow-1 overflow-auto pt-3">
          <Link to="/client-area/gmb/dashboard" className={`commerce_nav-link ${activeMenu === "Dashboard" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Dashboard")}>
            <FaTachometerAlt className="me-3" size={16} />
            <span>Dashboard</span>
          </Link>

          {/* Menu with Submenu */}
          <div>
            <Link className={`commerce_nav-link ${activeMenu === "GMB" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("GMB")}>
            <FaBusinessTime className="me-3" size={16} />
            <span>GMB</span>
            </Link>
            {/* Sub Menu */}
            {activeMenu === "GMB" && (
              <div className="commerce_sub-menu-container">
                <Link className={`commerce_sub-menu-item ${activeSubMenu === "Add gmb" ? "commerce_active-sub" : ""}`} 
                onClick={async () => {
                  handleSubMenuClick("Add gmb");
                  startGoogleAuth(setLoading,setOpen,dataRef);
                }}
                >
                  Add gmb
                </Link>
                <Link to="/client-area/gmb/manage_gmb" className={`commerce_sub-menu-item ${activeSubMenu === "Manage gmb" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Manage gmb")}>
                  Manage gmb
                </Link>
                {Services?.is_enterprise === "1" && (
                    <Link className={`commerce_sub-menu-item ${activeSubMenu === "Manage gmb" ? "commerce_active-sub" : ""}`} onClick={() => {
                        try{
                          const decoded = jwtDecode(Accesstoken);
                          const data = btoa(JSON.stringify({'id':decoded.id}));
                          navigator.clipboard.writeText(`https://googlemybusines.link?state=${data}`);
                          SuccessToastContainer("Link generated and copied to clipboard successfully.")
                        }catch(e){
                          ErrorToastContainer("Oops! Something went wrong while generating the link. Please try again.");
                        }
                    }}>
                      Copy Link
                    </Link>
                )}
              </div>
            )}
          </div>

          <div>
            <Link className={`commerce_nav-link ${activeMenu === "Billing" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Billing")}>
            <FaDollarSign className="me-3" size={16} />
            <span>Billing</span>
            </Link>
            {/* Sub Menu */}
            {activeMenu === "Billing" && (
              <div className="commerce_sub-menu-container">
                <Link to="/client-area/gmb/subscription" className={`commerce_sub-menu-item ${activeSubMenu === "Subscription" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Subscription")}>
                  Subscription
                </Link>
                <Link to="/client-area/gmb/payment-history" className={`commerce_sub-menu-item ${activeSubMenu === "Payment History" ? "commerce_active-sub" : ""}`} onClick={() => handleSubMenuClick("Payment History")}>
                  Payment History
                </Link>
              </div>
            )}
          </div>
          <Link to="/client-area/gmb/review" className={`commerce_nav-link ${activeMenu === "Review" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Review")}>
            <FaStar className="me-3" size={16} />
            <span>Review List</span>
          </Link>
          <Link to="/client-area/gmb/refer_earn" className={`commerce_nav-link ${activeMenu === "Refer" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Refer")}>
            <FaGift className="me-3" size={16} />
            <span>Refer & Earn</span>
          </Link>

          <Link to={"https://wa.me/917501137266"} target="_blank" className={`commerce_nav-link ${activeMenu === "Need Help?" ? "commerce_active" : ""}`} onClick={() => handleMenuClick("Need Help?")}>
            <FaQuestionCircle className="me-3" size={16} />
            <span>Need Help?</span>
          </Link>
            <Link className="commerce_nav-link" onClick={()=> {
                Swal.fire({
                  title: "Are you sure?",
                  text: "You won't be able to Logout this!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes Logout",
                }).then((result) => {
                  removeToken();
                  if (result.isConfirmed) {
                    Swal.fire({
                      title: "Logout!",
                      text: "Logout Succesful",
                      icon: "success",
                      showConfirmButton: false,
                      timer: 1000,
                    });
                    setTimeout(() => {
                      window.history.pushState({}, "", "/");
                      window.dispatchEvent(new Event("popstate"));
                    }, 1000);
                  }
                });
            }}>
              <FaSignOutAlt className="me-3" size={16} />
              <span>Logout</span>
            </Link>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className={`commerce_main-content ${isSidebarOpen ? '' : 'commerce_expanded'}`}>
        
        {/* Top Navbar */}
        <div className="bg-white px-3 py-2 d-flex align-items-center justify-content-between shadow-sm sticky-top" style={{height: "70px"}}>
           <div className="d-flex align-items-center">
               <button 
                 className="btn btn-link text-secondary p-0 me-3" 
                 onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                 style={{ fontSize: "20px" }}
               >
                 <FaBars />
               </button>
               <span className="fw-bold d-md-none">Campaigning Tool</span>
           </div>
        </div>
        
        {/* Loader code */}
        {loading &&(
          <Loader />
        )}

        {lottieRef.current && (
          <Lottie
            style={{height: '100vh',width: '100vw',position: "fixed",top: "0",left: '0',zIndex: '1000'}}
            animationData={loaderAnimation}
            loop={false}
          />
        )}

        <BusinessModal
          open={open}
          onClose={() => setOpen(false)}
          data={dataRef}
          lottieRef={lottieRef}
          setLoading={setLoading}
        />

        {/* Content Body */}
        <div className="px-2 py-2" >
          <Outlet/>
        </div>
       
      </div>
    </div>
  );
};

export default Layout;